import { Component, effect, OnInit, Renderer2, ViewChild } from "@angular/core";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";

import {
  API_URLS,
  CABIN_THUMB_SLIDE_CONFIG,
  DETAIL_PAGE_SLIDE_CONFIG,
  FILE_PATH_CAGE,
  MOMENT_FORMAT_START_DATE,
  P_CALENDAR_DATE_FORMAT,
} from "../../../../config/app.constants";
import { GlobalService } from "../../../../shared/services/global.service";
import { Utils } from "../../../../shared/utils";

import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { SharedModule } from "primeng/api";
import { CalendarModule } from "primeng/calendar";
import Swiper from "swiper";
import { Globals } from "../../../../globals";
import { OutPostModalService } from "../../../../shared/header/outpost-list-modal/out-post-modal.service";
import { OutpostListModalComponent } from "../../../../shared/header/outpost-list-modal/outpost-list-modal.component";
import { HttpinterceptorService } from "../../../../shared/services/httpinterceptor.service";
import { LoginService } from "../../../../shared/services/login.service";
import { StarRatingComponent } from "../../star-rating/star-rating.component";

declare var $: any;

@Component({
  selector: "app-cage-details",
  templateUrl: "./cage-details.component.html",
  styleUrls: ["./cage-details.component.scss"],
  standalone: true,
  imports: [
    RouterLink,
    SlickCarouselModule,
    CommonModule,
    StarRatingComponent,
    FormsModule,
    CalendarModule,
    SharedModule,
    OutpostListModalComponent,
  ],
})
export class CageDetailsComponent implements OnInit {
  @ViewChild("checkout") checkout: any;

  submitted: boolean = false;

  cageId: string = "";
  petTypeId: string = "";
  currentPet: any;

  inwardDate: Date;
  outwardDate: Date;
  minInWardDate: Date;
  maxDate: Date;

  selectedDateArray = [];
  cageTypeGrid: any = [];
  petTypeList: any[];
  slides = [];
  pCalendarDateFormat: string = P_CALENDAR_DATE_FORMAT;

  isCageUnavailable: boolean = false;

  slideConfig = DETAIL_PAGE_SLIDE_CONFIG;

  cabinThumbSlideConfig = CABIN_THUMB_SLIDE_CONFIG;
  selectedOutpostId;
  currentBoardService;
  apiParams = {};
  showOutpostModal: boolean = false;
  selectedOutpost: any = "";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpinterceptorService,
    private globalService: GlobalService,
    private globals: Globals,
    public loginService: LoginService,
    private outpostModalService: OutPostModalService,
    private modalService: NgbModal,
    private renderer: Renderer2
  ) {
    if (localStorage.getItem("selectedOutpostId")) {
      this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    }

    let today = new Date();
    today.setDate(today.getDate() + 25);
    this.maxDate = today;

    effect(() => {
      const el = this.outpostModalService.currentBoardService();
      if (el) {
        if (localStorage.getItem("selectedOutpostId")) {
          this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
        }
        this.getCageDetails();
      }
    });
  }

  ngOnInit() {
    this.minInWardDate = new Date();
    this.minInWardDate.setDate(this.minInWardDate.getDate() + 1); // Tomorrow Date
    this.minInWardDate.setHours(0, 0, 0, 0); // Set time to start of the day

    this.route.params.subscribe((params) => {
      this.cageId = params["id"];
      this.petTypeId = params["petTypeId"];
      this.getCageDetails();
    });
    this.getCurrentPetType();

    // this.currentBoardService =
    //   this.outpostModalService.currentBoardService.subscribe((el: any) => {
    //     if (el) {
    //       if (localStorage.getItem("selectedOutpostId")) {
    //         this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    //       }
    //       this.getCageDetails();
    //     }
    //   });
  }

  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized.
    // Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    // Ensure Swiper is initialized after data is fetched
    this.initSwiper();
  }

  initSwiper() {
    const galleryThumbs = new Swiper(".gallery-thumbs", {
      spaceBetween: 16,
      slidesPerView: 4.4,
      watchSlidesProgress: true,
      centerInsufficientSlides: true,
      slideToClickedSlide: true,
    });
    new Swiper(".gallery-top", {
      spaceBetween: 10,
      thumbs: {
        swiper: galleryThumbs,
      },
      on: {
        slideChange: function () {
          let activeIndex = this.activeIndex + 1;

          document.querySelector(
            `.gallery-thumbs .swiper-slide:nth-child(${activeIndex})`
          );
          let nextSlide = document.querySelector(
            `.gallery-thumbs .swiper-slide:nth-child(${activeIndex + 1})`
          );
          let prevSlide = document.querySelector(
            `.gallery-thumbs .swiper-slide:nth-child(${activeIndex - 1})`
          );

          if (
            nextSlide &&
            !nextSlide.classList.contains("swiper-slide-visible")
          ) {
            this.thumbs.swiper.slideNext();
          } else if (
            prevSlide &&
            !prevSlide.classList.contains("swiper-slide-visible")
          ) {
            this.thumbs.swiper.slidePrev();
          }
        },
      },
    });
  }

  getCageDetails() {
    this.http
      .post(
        API_URLS.GET_CAGE_TYPE_DETAILS,
        { cage_type_id: this.cageId, out_post_id: this.selectedOutpostId },
        false
      )
      .subscribe(
        (response) => {
          this.slides = [];
          if (response.data) {
            if (response.data.size) {
              const data = response.data.size.split(",");
              response.data["width"] = data[0];
              response.data["height"] = data[1];
              response.data["length"] = data[2];
              response.data["unit"] = data[3];
            }
            this.cageTypeGrid = response.data;

            if (
              response.data.cover_image ||
              response.data.outpost_images.cover_images
            ) {
              this.slides.push({
                img: this.getPaths(
                  response.data.outpost_images &&
                    response.data.outpost_images.cover_images
                    ? response.data.outpost_images.cover_images
                    : response.data.cover_image,
                  "cover"
                ),
                alt: "Cage Image",
                title: response.data.title,
              });

              if (
                response.data.outpost_images &&
                response.data.outpost_images.images
              ) {
                response.data.outpost_images.images =
                  response.data.outpost_images.images.split(",");
                for (const index in response.data.outpost_images.images) {
                  if (
                    Object.prototype.hasOwnProperty.call(
                      response.data.outpost_images.images,
                      index
                    )
                  ) {
                    const path = this.getPaths(
                      response.data.outpost_images.images[index],
                      "slider"
                    );
                    this.slides.push({
                      img: path,
                      alt: "Cage Image",
                      title: response.data.title,
                    });
                  }
                }
              } else if (response.data.images) {
                response.data.images = response.data.images.split(",");
                for (const index in response.data.images) {
                  if (
                    Object.prototype.hasOwnProperty.call(
                      response.data.images,
                      index
                    )
                  ) {
                    const path = this.getPaths(
                      response.data.images[index],
                      "slider"
                    );
                    this.slides.push({
                      img: path,
                      alt: "Cage Image",
                      title: response.data.title,
                    });
                  }
                }
              }
            }
          }
        },
        (error) => {
          this.router.navigate(["/"]);
        }
      );
  }

  bookCage(cageTypeGrid, content) {
    if (cageTypeGrid?.is_available_for_outpost) {
      this.openModalContent(content);
    }
  }

  getSelectedDays(date) {
    if (!this.outwardDate) {
      if (this.inwardDate) {
        const format = date.day + "/" + (date.month + 1) + "/" + date.year;
        return this.selectedDateArray.includes(format);
      }
    } else {
      const format = date.day + "/" + (date.month + 1) + "/" + date.year;
      return this.selectedDateArray.includes(format);
    }
  }

  selectInwardDate() {
    if (this.inwardDate) {
      this.selectedDateArray = [];
      const date = Utils.getDateFormat(this.inwardDate);
      this.selectedDateArray.push(date[0] + "/" + date[1] + "/" + date[2]);
      const expectedOutwardDate = this.addDays(this.inwardDate, 1);
      this.outwardDate = expectedOutwardDate;
      const expectedOutward = Utils.getDateFormat(expectedOutwardDate);
      this.selectedDateArray.push(
        expectedOutward[0] + "/" + expectedOutward[1] + "/" + expectedOutward[2]
      );
      this.checkout?.showOverlay(
        this.checkout?.inputfieldViewChild.nativeElement
      );
    }
  }

  selectOutwardDate() {
    const inwardDate = Utils.getDateFormat(this.inwardDate);
    const outwardDate = Utils.getDateFormat(this.outwardDate);
    const checkInDate =
      inwardDate[0] + "/" + inwardDate[1] + "/" + inwardDate[2];
    const checkoutDate =
      outwardDate[0] + "/" + outwardDate[1] + "/" + outwardDate[2];
    if (checkInDate == checkoutDate) {
      this.outwardDate = null;
      this.selectInwardDate();
      return false;
    } else {
      const checkInDiff = moment(checkInDate, MOMENT_FORMAT_START_DATE);
      const checkoutDiff = moment(checkoutDate, MOMENT_FORMAT_START_DATE);
      const totalDays = checkoutDiff.diff(checkInDiff, "days");
      this.selectedDateArray = [];
      const date = Utils.getDateFormat(this.inwardDate);
      this.selectedDateArray.push(date[0] + "/" + date[1] + "/" + date[2]);
      for (let i = 1; i <= totalDays; i++) {
        const expectedOutwardDate = this.addDays(this.inwardDate, i);
        const expectedOutward = Utils.getDateFormat(expectedOutwardDate);
        this.selectedDateArray.push(
          expectedOutward[0] +
            "/" +
            expectedOutward[1] +
            "/" +
            expectedOutward[2]
        );
      }
    }
  }

  addDays(date, count) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + count);
    return newDate;
  }

  checkCageAvailability() {
    this.submitted = true;
    let inward_date;
    let outward_date;
    if (this.inwardDate && this.outwardDate) {
      const inwardDate = Utils.getDateFormat(this.inwardDate);
      const outwardDate = Utils.getDateFormat(this.outwardDate);
      inward_date = inwardDate[1] + "/" + inwardDate[0] + "/" + inwardDate[2];
      outward_date =
        outwardDate[1] + "/" + outwardDate[0] + "/" + outwardDate[2];
    } else {
      return false;
    }
    this.http
      .post(
        API_URLS.CHECK_CAGE_AVAILABILITY,
        {
          cage_type_id: this.cageTypeGrid.id,
          inward_date: inward_date,
          outward_date: outward_date,
          out_post_id: this.selectedOutpostId,
        },
        false
      )
      .subscribe((response) => {
        if (response.data) {
          if (response.data.status === "available") {
            this.isCageUnavailable = false;
            this.closeModalContent();
            this.setSession();
            if (!jQuery.isEmptyObject(this.globals.currentUser)) {
              this.router.navigate([
                "/cage_booking",
                this.petTypeId,
                this.cageId,
              ]);
            } else {
              this.loginService.openLoginModal(
                "login",
                "/cage_booking/" + this.petTypeId + "/" + this.cageId
              );
            }
          } else {
            this.isCageUnavailable = true;
          }
        }
      });
  }

  setSession() {
    if (this.inwardDate) {
      const sessionObject = {
        fromDate: this.inwardDate,
        toDate: this.outwardDate,
        totalPets: 1,
      };
      sessionStorage.removeItem("filterRanges");
      sessionStorage.filterRanges = JSON.stringify(sessionObject);
    }
  }

  getPaths(FileName, type) {
    let path = "";
    if (this.cageTypeGrid.id) {
      if (type === "slider") {
        path = FILE_PATH_CAGE + this.cageTypeGrid.id + "/" + FileName;
      }
      if (type === "cover") {
        path =
          FILE_PATH_CAGE + this.cageTypeGrid.id + "/cover_image/" + FileName;
      }
    }
    return path;
  }

  getCurrentPetType() {
    this.globalService.getPetTypes().subscribe((data) => {
      this.petTypeList = data;
      this.currentPet =
        this.petTypeList[
          this.petTypeList.indexOf(
            this.petTypeList.find(({ id }) => {
              return id == this.petTypeId;
            })
          )
        ];
    });
  }

  backToCageList() {
    this.router.navigate(["boarding-service", this.petTypeId]);
  }
  onSelect(cageId) {
    if (localStorage.getItem("selectedOutpostId")) {
      this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    }
    this.apiParams = {
      service_id: cageId,
      service_type: "boarding",
    };
    const modalRef = this.modalService.open(OutpostListModalComponent, {
      size: "xl",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });

    modalRef.componentInstance.fromParent = { data: this.apiParams };
    modalRef.componentInstance.closeOutpostModal.subscribe(
      (response) => {
        if (response) {
          this.selectedOutpost = response.title;
          this.selectedOutpostId = response.id;
          this.getCageDetails();
          this.storeOutpostIdInLocalStorage();
        }
        window.scrollTo(0, 0);
      },
      (reason) => {}
    );
  }

  closeOutpostModal(data) {
    this.showOutpostModal = false;
    if (data) {
      this.selectedOutpost = data.title;
      this.selectedOutpostId = data.id;
      this.getCageDetails();
      this.storeOutpostIdInLocalStorage();
    }
  }
  storeOutpostIdInLocalStorage() {
    if (localStorage.getItem("selectedOutpostId")) {
      localStorage.removeItem("selectedOutpostId");
      localStorage.setItem("selectedOutpostId", this.selectedOutpostId);
    } else {
      localStorage.setItem("selectedOutpostId", this.selectedOutpostId);
    }
  }
  openModalContent(content) {
    this.modalService.open(content, {
      size: "lg",
      centered: true,
      backdrop: "static",
      keyboard: false,
      windowClass: "modal-bg-blue",
    });
  }
  closeModalContent() {
    this.modalService.dismissAll();
  }
  addClassOnDatePicker() {
    const calendarElement = document.querySelector(".p-datepicker");
    if (calendarElement) {
      this.renderer.removeClass(calendarElement, "modal-p-datepicker");
      this.renderer.addClass(calendarElement, "modal-p-datepicker");
    }
  }
}
